import(/* webpackMode: "eager" */ "/Users/yangyang/Repos/sw/.claude/worktrees/agent-a866b728a7fc91b23/apps/buywisely/app/error.tsx");
